import * as React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "@order-analyzer/ui";
import { AuthProvider } from "./auth.js";
import { BrandingProvider } from "./brandingContext.js";
import { getStoredTheme, applyTheme } from "./theme.js";
import { App } from "./App.js";
import "./index.css";

applyTheme(getStoredTheme());

// Der Guard in ChunkErrorBoundary verhindert eine Reload-Schleife bei WEITERHIN fehlschlagenden
// Chunk-Ladevorgängen. Da main.tsx nur ausgeführt wird, wenn index.html + das Hauptbundle bereits
// erfolgreich geladen wurden, ist dieser Stand nachweislich intakt - der Guard darf daher wieder
// zurückgesetzt werden, damit ein späterer, neuer Deploy im selben Tab erneut automatisch
// behoben werden kann.
sessionStorage.removeItem("oa-chunk-reload-once");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrandingProvider>
        <AuthProvider>
          <ToastProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ToastProvider>
        </AuthProvider>
      </BrandingProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
